
import { HashRouter, BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useEffect } from "react"
import Home from './Home.js'

import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import CardsPage from "./gallery.js";

function App() {
  useEffect(() => {
  }, [])
  return (
    <HashRouter>
      <Routes >
        <Route exact path="" element={<Home />} />
        <Route path="/gallery" element={<CardsPage />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
